/*
 * @Description:合同相关api
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-24 18:55:15
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
/**
 * @description: 销售合同接口列表
 * @return {*}
 * @author: 胡彩丽 hucaili@qfei.cn
 */
import { BaseService } from './base-service';
class ContractService extends BaseService {
  /**
   * @description: 获取数据列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getContractList(data) {
    return this.request({
      method: 'post',
      url: `/contract/list`,
      data
    });
  }
  /**
   * @description: 作废销售合同
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  delContract(data) {
    return this.request({
      method: 'get',
      url: `/contract/invalid`,
      params: data
    });
  }

  /**
   * @description: 合同列表--关联客户
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  relateCustomer(data) {
    return this.request({
      method: 'get',
      url: `/contract/bindCustomer`,
      params: data
    });
  }
  /**
   *  E签宝--发起签署
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  startSigning(params) {
    return this.request({
      method: 'get',
      url: `/contract/esign`,
      params
    });
  }
}
export const contractService = new ContractService();
